import type { ByVehicleRow } from '../alertTypes'
import { EntityRankView, type EntityRankConfig } from './EntityRankView'
import type { ViewProps } from './viewKit'

const CONFIG: EntityRankConfig<ByVehicleRow> = {
  path: '/by-vehicle',
  idColumn: 'vehicle_id',
  filterKey: 'vehicle',
  noun: { one: 'vehicle', many: 'vehicles' },
  spreadColumn: 'drivers',
  columns: [
    'vehicle_id', 'alerts', 'critical', 'warn', 'night_alerts', 'drivers', 'kinds', 'top_kind',
    'km', 'alerts_per_100km', 'first_ts', 'last_ts',
  ],
  tableId: 'alerts-by-vehicle',
  exportName: 'alerts-by-vehicle',
  title: 'Alerts by vehicle',
  noData: {
    title: 'No alerts in this window',
    body: 'Nothing fired for this site between these dates. Widen the window, or check the pipeline is running before reading this as a clean week.',
  },
}

/** Per-vehicle alert profile. A vehicle with many drivers and a high rate points at the
 *  truck (sensor, governor, route); one driver and a high rate points at the driver. */
export function VehiclesView(props: ViewProps): JSX.Element {
  return <EntityRankView<ByVehicleRow> {...props} config={CONFIG} />
}
